// FloatingButtons.jsx
import { Phone, MessageCircle } from "lucide-react";

export default function FloatingButtons() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3">
      
      {/* Call Button */}
      <a
        href="tel:9006236133"
        className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition"
      >
        <Phone size={22} />
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/919006236133"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-400 hover:bg-green-500 text-white p-4 rounded-full shadow-lg transition"
      >
        <MessageCircle size={22} />
      </a>

    </div>
  );
}